export default "__VITE_ASSET__DPa83Qjm__"